import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createDisciplinaryRecord } from '../../../store/actions/disciplinaryRecordsActions'
import ModalActionButton from '../../elements/ModalActionButton'
import TextareaField from '../../elements/form/TextareaField'
import SelectField from '../../elements/form/SelectField'
import TextField from '../../elements/form/TextField'
import { ERROR, GET_STUDENTS } from '../../../store/types'
import NumberField from '../../elements/form/NumberField'
import ChevronIcon from '../../elements/icons/ChevronIcon'
import SearchField from '../../elements/SearchField'
import { debounce } from '../../../utils'
import { fetchStudents } from '../../../store/actions/studentsActions'
import TrashIcon from '../../elements/icons/TrashIcon'
import RadioGroup from '../../elements/form/RadioGroup'

const NewDisciplinaryRecord = ({student, close}) => {
    const disciplinaryRecordsSelector = useSelector(state => state.disciplinaryRecords)

    const [recordPayload, setRecordPayload] = useState({})

    const dispatch = useDispatch()
    const [validationErrors, setValidationErrors] = useState({})

    const validateForm = () => {
        let errors = {}

        if(!recordPayload.description || recordPayload.description === '') {
            errors.descripton = true
        }

        if(!recordPayload.penaltyType || recordPayload.penaltyType === '') {
            errors.penaltyType = true
        }

        if(!recordPayload.penaltyDurationType || recordPayload.penaltyDurationType === '') {
            errors.penaltyDurationType = true
        }

        if(recordPayload.penaltyDurationType !== 'indefinite' && (!recordPayload.penaltyDurationLength || recordPayload.penaltyDurationLength === '')) {
            errors.penaltyDurationLength = true
        }

        setValidationErrors(errors)
        console.log(errors)
        return errors
    }

    const pushRecord = () => {
        if(Object.values(validateForm()).includes(true)){
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }
        try {
            const payload = {
                description: recordPayload.description,
                students: [student , ...otherStudents.map(item => item._id)],
                penalty: {
                    type: recordPayload.penaltyType,
                    description: recordPayload.penaltyDescription,
                    duration: {
                        type: recordPayload.penaltyDurationType,
                        length : recordPayload.penaltyDurationLength
                    },
                    status: recordPayload.penaltyStatus
                }
            }
            dispatch(createDisciplinaryRecord(payload))

        } catch (error) {
            console.error(error)
        }
    }

    const penaltyTypes = [
        {
            label: 'Probation',
            value:'probation'
        },
        {
            label: 'Fine',
            value:'fine'
        },
        {
            label: 'Detention',
            value:'detention'
        },
        {
            label: 'Suspension',
            value:'suspension'
        },
        {
            label: 'Expulsion',
            value:'expulsion'
        },
        {
            label: 'Other',
            value:'other'
        },
    ]

    const penaltyPeriodOpptions = [
        {
            label: 'Hours',
            value: 'hours'
        },
        {
            label: 'Days',
            value: 'days'
        },
        {
            label: 'Weeks',
            value: 'weeks'
        },
        {
            label: 'Months',
            value: 'months'
        },
        {
            label: 'Years',
            value: 'years'
        },
        {
            label: 'Indefinite',
            value: 'indefinite'
        },
    ]

    const statusOptions = [
        {
            label: 'Pending',
            value: 'pending'
        },
        {
            label: 'In Progress',
            value: 'in-progress'
        },
        {
            label: 'Completed',
            value: 'completed'
        }
    ]

    const [addingOthers, setAddingOthers] = useState(false)
 
    const studentsSelector = useSelector(state => state.students)
 
    const searchStudents = debounce((term) => {
        if(!term || term === '') {
            dispatch({
                type: GET_STUDENTS,
                payload: []
            })
        }
        dispatch(fetchStudents(`searchTerm=${term}`, 0, 0))
    })

    const [otherStudents, setOtherStudents] = useState([])

    const addStudent = (student) => {
        const temp = [...otherStudents]
        temp.push(student)
        setOtherStudents(temp)
    }

    const removeStudent = (index) => {
        const temp = [...otherStudents]
        temp.splice(index, 1)
        setOtherStudents(temp)
    }

    return (
        <div className='w-full'>

            <div className='my-2 w-full'>
                <TextareaField
                    inputLabel="Descriptiom" 
                    fieldId="status-note" 
                    inputPlaceholder={`Describe the incident that attracted this record`}
                    inputType="text" 
                    requiredField={false}
                    preloadValue={recordPayload.descrption || ''}
                    hasError={validationErrors && validationErrors.description} 
                    returnFieldValue={(value)=>{setRecordPayload({...recordPayload, ...{description: value}})}}
                />
            </div>

            <div className='bg-gray-100 rounded p-[10px] relative mb-[10px] '>
                <div onClick={()=>{setAddingOthers(!addingOthers)}} className='w-full cursor-pointer flex items-center jutify-between gap-x-[10px] transition duration-200'>
                    <div className='w-full'>
                        <h3 className='text-[14px] text-gray-700 font-medium mt-[20pz]'>Add other students</h3>
                        <p className='text-xs text-gray-600'>You can click here to add other students in this report. Do this if you want them to also have this record and their parents notified as well.</p>
                    </div>
                    <div className='w-[30px]'>
                        <ChevronIcon className={`w-4 h-4 text-gray-800 transition duration-200 ${addingOthers ? 'rotate-[270deg]' : 'rotate-[90deg]'}`} />
                    </div>
                </div>

                {addingOthers && 
                <>
                    {otherStudents.length > 0 && <div className='w-full mb-[10px] flex flex-wrap gap-x-[5px] mt-[15px]'>
                        {otherStudents.map((student, studentIndex)=>(
                            <div key={studentIndex} className='p-[7px] w-max flex items-center gap-x-[5px] rounded bg-gray-200 text-gray-700 font-medium font-space-grotesk text-xs'>
                                {student.fullName} 
                                <button onClick={()=>{removeStudent(studentIndex)}}><TrashIcon className={`w-4 h-4`} /></button>
                            </div>))}
                    </div>}
                    <div className='w-full mt-[20px] mb-[10px]'>
                        <SearchField 
                            placeholderText={`Search by student name or admission number`}
                            showResultsDropDown={true}
                            triggerSearch={(term)=>{searchStudents(term)}}
                            performingSearch={studentsSelector.loadingStudents}
                            searchResults={studentsSelector?.students?.students}
                            selectResult={(result)=>{addStudent(result)}}
                            resultDisplayField={`fullName`}
                        />
                    </div>
                </>
                }
            </div>

            

            <h3 className='text-[15px] font-medium mt-[20px]'>Penalties</h3>
            <p className='text-sm text-gray-600'>Please provide details of the penalty for the above actions</p>

            <div className='my-4'>
                <SelectField 
                    selectOptions={penaltyTypes} 
                    preSelectedIndex={penaltyTypes.findIndex(item => item.value === recordPayload.penaltyType)}
                    inputLabel={'Penalty Type'}
                    requiredField={true}
                    returnFieldValue={(value) => {setRecordPayload({...recordPayload, ...{penaltyType: value.value}})}} 
                    hasError={validationErrors && validationErrors.penaltyType}  
                    titleField='label'
                    fieldId='penalty-type'
                />
            </div>

            <div className='my-2'>
                <TextField
                    inputLabel="Description of penalty" 
                    fieldId="fee-name" 
                    inputPlaceholder={`How will the students be penalized?`}
                    inputType="text" 
                    requiredField={false}
                    preloadValue={recordPayload.penaltyDescription || ''}
                    hasError={false} 
                    returnFieldValue={(value)=>{setRecordPayload({...recordPayload, ...{penaltyDescription: value}})}}
                />
            </div>

            <div className='w-full flex items-start justify-between gap-x-[10px]'>
                <div className='my-2 w-[70%]'>
                    <SelectField 
                        selectOptions={penaltyPeriodOpptions} 
                        preSelectedIndex={penaltyPeriodOpptions.findIndex(item => item.value === recordPayload.penaltyType)}
                        inputLabel={'Duration type'}
                        requiredField={true}
                        returnFieldValue={(value) => {setRecordPayload({...recordPayload, ...{penaltyDurationType: value.value}})}} 
                        hasError={validationErrors && validationErrors.penaltyDurationType}  
                        titleField='label'
                        fieldId='penalty-duration-type'
                    />
                </div>
                <div className='w-[30%] my-2'>
                    <NumberField
                        inputType="number" 
                        fieldId={`penalty-length`}
                        inputLabel="Length" 
                        requiredField={recordPayload.penaltyPeriodType !== 'indefinite'}
                        preloadValue={''}
                        inputPlaceholder={`how long?`}
                        hasError={validationErrors && validationErrors.penaltyDurationLength} 
                        disabled={recordPayload.penaltyPeriodType === 'indefinite'}
                        returnFieldValue={(value)=>{setRecordPayload({...recordPayload, penaltyDurationLength: value})}}
                    />
                </div>
            </div>

            <div className='mt-4'>
                <RadioGroup 
                    items={statusOptions} 
                    inline={true}
                    preSelectedIndex={statusOptions.findIndex(item => item.value === recordPayload.status)}
                    inputLabel={'Penalty Status'}
                    requiredField={true}
                    returnSelected={(value) => {setRecordPayload({...recordPayload, ...{penaltyStatus: value.value}})}} 
                    hasError={validationErrors && validationErrors.type}  
                    titleField='label'
                />
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Create Disciplnary Record`}
                    buttonAction={()=>{pushRecord()}}
                    processing={disciplinaryRecordsSelector.creatingDisciplinaryRecord}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default NewDisciplinaryRecord